import type { ISeoMetadataFields } from '@/types/contentful'

export default class SeoInjector {
  metaAttributes: any[]
  linkAttributes: any[]
  data: ISeoMetadataFields

  constructor(metaData: ISeoMetadataFields) {
    this.data = metaData
    this.metaAttributes = []
    this.linkAttributes = []
  }

  setIndexAttribute(noIndex = false) {
    this.metaAttributes.push({ hid: 'robots', name: 'robots', content: noIndex ? 'nofollow' : 'follow' })
  }

  setFollowAttribute(noFollow = false) {
    this.metaAttributes.push({ hid: 'robots', name: 'robots', content: noFollow ? 'nofollow' : 'follow' })
  }

  setHrefLang(url: string | undefined, attributeValue: string) {
    if (url) {
      this.linkAttributes.push({ rel: 'alternate', hrefLang: attributeValue, href: url })
    }
  }

  setCanonical(canonicalUrl: string | undefined) {
    if (canonicalUrl) {
      this.linkAttributes.push({ rel: 'canonical', href: canonicalUrl })
    }
  }

  setSeoMeta() {
    useSeoMeta({
      title: this.data.seoTitle,
      description: this.data.description,
      keywords: this.data.keywords?.reduce((keyword, previousValue) => `${previousValue}, ${keyword}`, ''),
    })
  }

  inject() {
    this.setHrefLang(this.data.hrefLangPl || undefined, 'pl')
    this.setHrefLang(this.data.hrefLangEn || undefined, 'en')
    this.setHrefLang(this.data.hrefLangDefault || undefined, 'x-default')
    this.setCanonical(this.data.canonical || undefined)
    this.setSeoMeta()
    useHead(() => ({ meta: this.metaAttributes, link: this.linkAttributes }))
  }
}
